module.exports = __webpack_public_path__ + "img/rotherham-logo.8f57e818.svg";